import { getPartners, type PartnerFilterDto } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const PARTNER_LIST = "PARTNER_LIST";

export const getPartnerListQueryKey = (filter: PartnerFilterDto) => [
	PARTNER_LIST,
	filter.marketId,
	filter.name,
	filter.middleName,
	filter.surname,
	filter.email,
	filter.phone,
	filter.skills,
	filter.teamSize,
	filter.isCanTrainDay,
	filter.status,
	filter.query,
	filter.pageLimit,
	filter.pageIndex,
	filter.orderBy,
	filter.orderDirection ?? undefined,
	filter.verticals,
];

export function usePartnersListQuery(filter: PartnerFilterDto) {
	return useQuery({
		queryKey: getPartnerListQueryKey(filter),
		queryFn: processResponse(() =>
			getPartners(
				filter.marketId,
				filter.name,
				filter.middleName,
				filter.surname,
				filter.email,
				filter.phone,
				filter.skills ?? undefined,
				filter.teamSize,
				filter.isCanTrainDay,
				filter.status ?? undefined,
				filter.query,
				filter.pageLimit,
				filter.pageIndex,
				filter.orderBy,
				filter.orderDirection ?? undefined,
				filter.verticals,
			),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
